var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c(
        "Modal2",
        {
          attrs: {
            showTitle: false,
            showFooter: false,
            className: "mail-settings-modal",
          },
          on: { cancel: _vm.close },
        },
        [
          _c("div", { staticClass: "settings-content" }, [
            _c("div", { staticClass: "setting-item" }, [
              _c("div", { staticClass: "setting-label" }, [
                _vm._v(_vm._s(_vm.$t("mail.viewMode"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "setting-control view-mode-options" }, [
                _c(
                  "div",
                  {
                    staticClass: "view-mode-option",
                    class: { active: !_vm.isGridMode },
                    on: {
                      click: function ($event) {
                        return _vm.setLayoutMode(false)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "option-icon no-split" }, [
                      _c("div", { staticClass: "icon-box" }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v(_vm._s(_vm.$t("mail.singleView"))),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "view-mode-option",
                    class: { active: _vm.isGridMode },
                    on: {
                      click: function ($event) {
                        return _vm.setLayoutMode(true)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "option-icon with-split" }, [
                      _c("div", { staticClass: "split-left" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "split-right" }, [
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "line" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "option-label" }, [
                      _vm._v(_vm._s(_vm.$t("mail.splitView"))),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }